import { Modal } from 'antd'
import { useContext } from 'react'
import { useDeleteWorkareaGroupMutation } from '../../../../domain/workareas/groupsQueries'
import JobPlanContext from '../JobPlanContext'

type Props = {
  isOpen: boolean
  onCancel: () => void
  workareaGroupId: string | undefined
  workareaGroupName: string | undefined
  workareaCount: number | undefined
  jobId: number
}

const DeleteWorkareaGroupModal = ({ isOpen, onCancel, jobId, workareaGroupId, workareaGroupName, workareaCount }: Props) => {
  const { currentSelection, clearSelection } = useContext(JobPlanContext)
  const hasWorkareas = (workareaCount ?? 0) > 0
  const deleteWorkareaGroupMutation = useDeleteWorkareaGroupMutation(() => { 
    onCancel()
  
    if(currentSelection?.groupId === workareaGroupId)
    {
      clearSelection()
    }
  })

  const handleDelete = () => {
    if(workareaGroupId){
      deleteWorkareaGroupMutation.mutate({ jobId, workareaGroupId })
    }
  }

  return <Modal
    title={<p>Are you sure you want to delete <strong>{workareaGroupName}</strong>?</p>}
    open={isOpen}
    onOk={handleDelete}
    onCancel={onCancel}
    okText="Delete"
    cancelText="Cancel"
    okButtonProps={{ danger: true, loading: deleteWorkareaGroupMutation.isLoading, disabled: deleteWorkareaGroupMutation.isLoading }}
    cancelButtonProps={{ disabled: deleteWorkareaGroupMutation.isLoading }}
  >
    {
      hasWorkareas
      ? `This group has ${workareaCount} work areas. Deleting the group will also delete all work area within it. This action cannot be undone.`
      : 'This action cannot be undone.'
    }
  </Modal>
}

export default DeleteWorkareaGroupModal